module.exports = __webpack_public_path__ + "img/70.3700a478.jpg";